<template>
    <div id="app" class="app fade-in">
        <SiteHeader />
        <transition name="fade-slide" mode="out-in">
            <main :key="$route.path">
                <router-view></router-view>
            </main>
        </transition>
        <SiteFooter />
    </div>
</template>

<script>
    import SiteHeader from './components/SiteHeader.vue';
    import SiteFooter from './components/SiteFooter.vue';

    export default {
        name: 'App',
        components: {
            SiteHeader,
            SiteFooter
        }
    };
</script>

<style>
    #app {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
    }

    .fade-in {
        opacity: 0;
        animation: fadeIn ease-in 1s forwards;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    main {
        flex: 1;
        background-color: #ebf3ed;
        padding: 0 2rem 0 2rem;
    }

    html {
        scroll-behavior: smooth;
    }

    .fade-slide-enter-active, .fade-slide-leave-active {
        transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
        will-change: transform, opacity;
    }

    .fade-slide-enter-from {
        transform: translateX(50px);
        opacity: 0;
    }

    .fade-slide-enter-to {
        transform: translateX(0);
        opacity: 1;
    }

    .fade-slide-leave-from {
        transform: translateX(0);
        opacity: 1;
    }

    .fade-slide-leave-to {
        transform: translateX(-50px);
        opacity: 0;
    }

    @media (max-width: 768px) {
        main {
            padding: 0 1rem 0 1rem;
        }
    }
</style>